<div class="upp-dialog" tabindex="0" (click)="OnBackdropClick()" (keydown)="OnBackdropKeydown($event)">
    <div class="upp-dialog__panel" tabindex="0" (click)="OnPanelClick($event)" (keydown)="OnPanelKeydown($event)">
        <ng-content></ng-content>
    </div>
</div>
